<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form">
            <!-- 表单-选择栏-订单状态 {0:查询全部, 1:已支付, 2:支付失败, 3:已撤销, 4:未支付} -->
            <div class="md-layout-item md-size-30 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("state")}}</label>
                <md-select v-model="searchForm.order_state">
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option value="1">{{$I18n('ref_pro')}}</md-option>
                  <md-option value="2">{{$I18n('ref_succ')}}</md-option>
                  <md-option value="3">{{$I18n('ref_fail')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 检索按钮 {小屏幕模式} -->
            <div class="md-layout-item left-layout-item md-xsmall-size-50" style="padding-top: 8px;">
                <md-button class="md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 订单数据卡片 -->
    <div class="md-layout-item md-size-100" v-for="(order,index) in tableData" :key="index">
      <md-card class="order-card" >
        <!-- 卡片-头部 -->
        <md-card-header>
          <!-- 创建时间 | 商品订单号 | 支付时间 | 支付订单号 | 区域 -->
          <div class="md-subhead no-left">
            <div class="order-card-title" style="margin-right: 150px;">
              <span :style="{'border-right':'1px solid #aaa','padding-right':'8px'}">{{$I18n("created_thing_time")}}:{{order.create_time}}</span>
              <span :style="{'border-right':'1px solid #aaa','padding-right':'8px'}">{{$I18n("order_id")}}:{{order.order_id}}</span>
              <span :style="{'border-right':'1px solid #aaa','padding-right':'8px'}" v-if="!!order.pay_time">{{$I18n("pay_time")}}:{{order.pay_time}}</span>
              <span :style="{'border-right':'1px solid #aaa','padding-right':'8px'}">{{$I18n("pay_order_id")}}:{{order.pay_order_id}}</span>
              <span :style="{'border-right':'1px solid #aaa','padding-right':'8px'}">{{$I18n("pay_plat_no")}}:{{order.refund.pay.platform_order_id}}</span>


              <span>{{$I18n("zone")}}:{{$I18n(order.zone)}}</span>
            </div>
          </div>
          <!-- 订单状态 (显示在右上角) -->
          <p  class="warning category order-card-title-state">
            {{order.refund.state_name}}
          </p>
        </md-card-header>
        <!-- 间隔线 -->
        <div class="line"></div>
        <!-- 卡片-主体 -->
        <md-card-content class="md-layout" >
          <!-- 图片 -->
          <div class="md-layout-item md-size-10 md-xsmall-size-100">
            <img :style="{'max-width':'300px'}" src="/img/timg.jpg">
          </div>
          <!-- 商品名称 | 所属公司 -->
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <div>{{order.name}}</div>
            <div>{{order.company_name}}</div>
          </div>
          <!-- 购买人ID | APP ID (没有的时候不显示) -->
          <div class="md-layout-item md-size-30 md-xsmall-size-100" v-if="order.user_id || order.app_id">
            <div v-if="order.user_id">{{$I18n("buy_id")}}:{{order.user_id}}</div>
            <div v-if="order.app_name">{{"APP"}}:{{order.app_name}}</div>
          </div>
          <!-- UID -->
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <div>{{$I18n("umid")}}:{{order.link_id}}</div>
            <div>{{$I18n("order_type")}}:{{$I18n("order_type_"+order.order_type)}}</div>
          </div>
          <!-- 订单价格 | 数量 -->
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-button v-if="order.refund.state == 1" class="md-info" @click="() => change_state(order.refund.id, order.refund.state)">
              {{$I18n("change_ref_state")}}
            </md-button>
          </div>
          <div class="md-layout-item md-size-10 md-xsmall-size-100"></div>
          <div class="md-layout-item md-size-90">
            {{$I18n("ref_reason")}}:{{order.refund.reason}}
          </div>
        </md-card-content>
        <!-- 卡片-底部  保存时间 | 有效时长 | 支付平台 | 商品成本 | 商品总额 | 实际收款 -->
        <md-card-actions>
          <div class="foot-box">
            <span v-if="order.attr.lifecycle">{{$I18n("save_time")}}:{{order.attr.lifecycle}}{{$I18n("day")}}</span>
            <span class="foot-box-left">{{$I18n("validity_day")}}:{{order.months}}{{$I18n("a_month")}}</span>
            <span class="foot-box-left">{{$I18n("ref_time")}}:{{order.refund.create_time}}</span>
            <span class="foot-box-left">{{$I18n("pro_time")}}:{{order.refund.update_time}}</span>
            <div class="foot-box-right" :style="{'display':'flex'}">
              <div>{{$I18n("pay_type")}}:{{order.pay_platform_name}}</div>
              <div v-if="order.comp_price">{{$I18n("cost")}}:¥{{order.comp_price}}</div>
              <div>{{$I18n("commod_price")}}:{{$I18n("money_type_" + order.currency)}}{{order.order_price}}</div>
              <div>{{$I18n("fact_price")}}:{{$I18n("money_type_" + order.currency)}}{{order.fact_price}}</div>
              <div>{{$I18n("ref_amount")}}:{{$I18n("money_type_" + order.currency)}}{{order.refund.price}}</div>
            </div>
          </div>
        </md-card-actions>
      </md-card>
    </div>
    <!-- 分页 -->
    <div class="md-layout-item md-size-100" >
      <md-card>
        <table-page :total="total" v-model="currentPage" :pageSize="pageSize"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "false"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 导出xls的选项  -->
        <div >
          <!-- <md-radio v-model="modalForm.state" :value="1">{{$I18n("ref_pro")}}</md-radio> -->
          <md-radio v-model="modalForm.state" :value="2">{{$I18n("ref_succ")}}</md-radio>
          <md-radio v-model="modalForm.state" :value="3">{{$I18n("ref_fail")}}</md-radio>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { timestampToString, /*FormClass*/ } from "@/common/tools.js";
export default {
  data() {
    return {
      searchForm : { // 查询表单用的数据
        order_state : 0,
      },
      modalForm: {
        id:"",
        state:1,
      },
      searchData: {}, // 检索范围
      // 表格相关
      icon  : "dns",
      title : this.$I18n("order_info"),
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModalType: "",
      openModal: false,
      modalTitle : this.$I18n("change_ref_state"),
    };
  },
  mounted : function() {
    this.api_getComp();
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    form_changeSearchData(){
      this.searchData = {
        state : parseInt(this.searchForm.order_state),
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    api_getSpec(compId){
      this.$api.getGood({
        comp_id: compId,
      })
        .then(this.$Then(resData => {
          this.productData = resData.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.specData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getRefundList({ // api: /mall/order/query
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("",() => {
          this.compData = [];
        }))
    },
    change_state(id,state){
      this.modalForm = {
        id   :id,
        state:state,
      }
      this.$refs.modal.open();
    },
    // 提交表单
    modal_submit () {
      this.$api.setRefundList({
        ...this.modalForm,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    comp_price(){
      let price = this.selectedSpec.comp_price
      if(isNaN(price)){
        return 0
      } else {
        return parseFloat(price)
      }
    },
    tableData(){ // 表格数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        let orderStateList = {
            1:this.$I18n("success"),
            2:this.$I18n("fail"),
            3:this.$I18n("revoke"),
            4:this.$I18n("undo"),
        }
        let refundStateList = {
            1:this.$I18n("ref_pro"),
            2:this.$I18n("ref_succ"),
            3:this.$I18n("ref_fail"),
        }
        return this.tableInitData.filter(ref_item => {
          return !!ref_item.order
        }).map(ref_item => {
          var item = ref_item.order;
          // 公司
          let company_name = this.$I18n("unknow");
          let comp = this.compData.filter(comp => comp.comp_id == item.comp_id)
          if(comp.length > 0){
            company_name = comp[0].comp_name;
          }
          // 状态 | 支付方式
          let state = orderStateList[item.order_state];
          let pay_platform_name = this.$I18n(this.$Param.payment.getName(item.pay_type, "unknow"));
          return {
            product_name : "",
            stock_name : "",
            order_fee : 0,
            ...item,
            attr: item.product_attr ?JSON.parse(item.product_attr) :{},
            company_name,
            state,
            pay_platform_name,
            create_time : timestampToString(new Date(item.create_time).getTime()),
            pay_time    : item.pay_time ? timestampToString(new Date(item.pay_time).getTime()) : "",

            refund : {
              pay:{},
              ...ref_item,
              state_name: refundStateList[ref_item.state],
              create_time: timestampToString(ref_item.gmt_create * 1000),
              update_time: timestampToString(ref_item.gmt_update * 1000),
            },
          }
        });
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px;
    text-align: left;
  }
  .md-chip{
    cursor:pointer;
    line-height: 24px;
    height: 24px;
    margin: 2px 3px !important;
  }
  .md-chip .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip:hover .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip.md-info{
    background: rgb(0, 188, 212) !important;
  }
  .md-chip.md-danger{
    background: #f44336 !important;
  }
  .md-info{
    margin-top : 0 !important;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
  }
  .order-card .foot-box .foot-box-right div{
    margin-right : 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  @media screen and ( max-width: 600px ){
    .md-card .md-subhead {
      margin-left: 0;
    }
    .order-card-title span{
      display:block;
    }
    .foot-box span, .foot-box div{
      width: 50%;
      margin-right: -16px !important;
      margin-left: 16px !important;
    }
    .order-card{
      padding: 16px 0;
    }
  }
</style>
